import { requestFactory, requestBase } from "@/plugins/axios";
// {pageinfo}
export function getMachine(params) {
  return requestFactory({
    url: "/machine/findList",
    method: "GET",
    params: params,
  });
}
// {pageinfo}
export function getUser(params) {
  return requestFactory({
    url: "/Worker/workerList",
    method: "GET",
    params: params,
  });
}
// {pageinfo}
export function getProductOreder(params) {
  requestFactory({
    url: "/productOrder/list",
    method: "GET",
    params: params,
  });
}
// {pageinfo}
export function getDefect(params) {
  requestFactory({
    url: "defectRecord/list",
    method: "GET",
    params: params,
  });
}

// 首页请求
export function getList(params) {
  return requestFactory({
    url: "/DailyData/findNowList",
    method: "GET",
    params: params,
  });
}

export function getDetailList(params) {
  return requestFactory({
    url: "/DailyData/machineStatus",
    method: "GET",
    params: params,
  });
}

export function getStateCanvasData(params) {
  return requestBase({
    url: "v1/factory/machine-state-chart",
    method: "GET",
    params: params,
  });
}

export function getWarn(data) {
  return requestFactory({
    url: "/machine/findById",
    method: "POST",
    data,
  });
}

export function getUpdateThreshold(data) {
  return requestFactory({
    url: "/machine/updateThreshold",
    method: "POST",
    data,
  });
}
